export function normalizeRecoloredImageSrc(src) {
    if (src == null)
        return undefined;
    return src.trim() === '' ? undefined : src;
}
export function normalizeMockupLogo(logo) {
    const next = normalizeRecoloredImageSrc(logo.recoloredImageSrc);
    if (next === logo.recoloredImageSrc)
        return logo;
    return Object.assign(Object.assign({}, logo), { recoloredImageSrc: next });
}
export function normalizeMockupLogos(logos) {
    return logos.map(normalizeMockupLogo);
}
export function logoTextureImageSrc(logo) {
    const r = normalizeRecoloredImageSrc(logo.recoloredImageSrc);
    return r !== null && r !== void 0 ? r : logo.imageSrc;
}
